import { convertToLocaleString, formatDataValue } from 'utils/formatFns';

export const qualityConfirmationsFields = {
  estimatedDelay: {
    label: 'Estimated Delay',
    getValue: (data) => data?.qualityConfirmations?.[0]?.estimatedDelayDays,
    formatValue: (value) => {
      if (!value) {
        return null;
      }
      return formatDataValue({ value: convertToLocaleString(value) });
    },
  },
  groupCodeDays: {
    label: 'Group Code | # of Days',
    getValue: (data) => ({
      delayGroupCode: data?.qualityConfirmations?.[0]?.delayGroupCode,
      estimatedDelayDays: data?.qualityConfirmations?.[0]?.estimatedDelayDays,
    }),
    formatValue: ({ delayGroupCode, estimatedDelayDays }) => {
      const formattedCode = formatDataValue({ value: delayGroupCode });
      const formattedDays = formatDataValue({
        value: convertToLocaleString(estimatedDelayDays),
      });
      return `${formattedCode} | ${formattedDays}`;
    },
  },
  qcNumber: {
    label: 'QC Number',
    getValue: (data) => data?.qualityConfirmations?.[0].stopSaleNumber,
    formatValue: (value) => formatDataValue({ value }),
  },
  qcReleaseDate: {
    label: 'QC Release Date',
    getValue: (data) => data?.qualityConfirmations?.[0]?.qcReleaseDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  qcStartDate: {
    label: 'QC Start Date',
    getValue: (data) => data?.qualityConfirmations?.[0]?.inspectDateFmt,
    formatValue: (value) => formatDataValue({ value }),
  },
  qcStatus: {
    label: 'QC Status',
    getValue: (data) => data?.qualityConfirmations?.[0].qualityConfirmationDescription,
    formatValue: (value) => formatDataValue({ value }),
  },
  qcYearCode: {
    label: 'QC Year | Code',
    getValue: (data) => ({
      qualityConfirmationYear: data?.qualityConfirmations?.[0]?.qualityConfirmationYear,
      stopSaleNumber: data?.qualityConfirmations?.[0]?.stopSaleNumber,
    }),
    formatValue: ({ qualityConfirmationYear, stopSaleNumber }) => {
      const formattedYear = formatDataValue({ value: qualityConfirmationYear });
      const formattedNumber = formatDataValue({ value: stopSaleNumber });
      return `${formattedYear} | ${formattedNumber}`;
    },
  },
};
